import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { Login } from '@services/api'
import { observer, inject } from 'mobx-react'
import loginStyles from './styles/LoginFormStyle'
import { IProps as ILoginProps } from '../Login'
import { getEnterpriseId } from './config'

interface IProps extends ILoginProps, WithStyles<typeof loginStyles> {}

@inject('UserStore', 'AppStore')
@observer
class LoginForm extends React.Component<IProps> {

  public render() {
    const { classes } = this.props
    return (
      <>
        <div className={classes.loginForm}>
          <div className={classes.loginContainer}>
            <div className={classes.title}>
              <div className={classes.welcome}>
                <span>欢迎使用</span>
                <span>e祺学</span>
              </div>
              <div className={classes.titleLine} />
            </div>
            <div className={classes.innerWrapper}>
              <div className={classes.loginZNButton} onClick={() => this.forceLogin(2)}>学习平台登录</div>
              <div className={classes.loginButton} onClick={() => this.forceLogin(1)}>管理平台登录</div>
              <div className={classes.loginLZKButton} onClick={() => this.forceLogin(3)}>来做课登录</div>
            </div>
          </div>
        </div>
      </>
    )
  }

  // 登录
  private forceLogin = async (clientSideType: number) => {
    const data = {
      clientSideType,
      enterpriseId: getEnterpriseId(),
    }
    const res = await Login.loginUrl(data)
    if ( res && res._failure ) { return }
    const { url } = res.body
    // 跳中车页面
    if (url) {
      window.location.href = url
    }
  }
}

export default withStyles(loginStyles)(LoginForm)
